//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('forecasts', {
//        templateUrl: 'views/components/views/forecasts/forecasts.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'forecastsService', function (stateService, forecastsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                itemsListForecasts: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCION CALL

//            async function loadForecasts() {
//                vm.model.itemsListForecasts = (await forecastsService.listForecasts());
//            }

//            // #endregion LOAD PROCEDURE FUNCION CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                let go = function (parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                };

//                switch (state) {
//                    case 'forecast':
//                        go({ forecast_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadForecasts();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
